<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pHHPJz/tc-custom/9780226821139.jpg?1731787838466" alt="This image is the cover for the book Stacked Decks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stacked Decks
      </h1>
      <p class="bookDescription body article font2">
        <b>A startling look at the power and perspectives of city building inspectors as they navigate unequal housing landscapes.</b><br/>  <br/> Though we rarely see them at work, building inspectors have the power to significantly shape our lives through their discretionary decisions. The building inspectors of Chicago are at the heart of sociologist Robin Bartram’s analysis of how individuals impact—or attempt to impact—housing inequality. In <i>Stacked Decks</i>, she reveals surprising patterns in the judgment calls inspectors make when deciding whom to cite for building code violations. These predominantly white, male inspectors largely recognize that they work within an unequal housing landscape that systematically disadvantages poor people and people of color through redlining, property taxes, and city spending that favor wealthy neighborhoods. <i>Stacked Decks</i> illustrates the uphill battle inspectors face when trying to change a housing system that works against those with the fewest resources.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robin Bartram
      </h2>
      
      <p class="authorDescription body article"><B>Robin Bartram</B> is assistant professor of sociology at Tulane University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e2c17e4